// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"351":"fc9c1f69","506":"0aae5a87","509":"d0165e9f","752":"93b3e000","931":"593394c5","935":"06f928a1"}[chunkId] + ".chunk.css";
};